import {useSnackbar} from 'notistack';
import * as R from 'ramda';
import React from 'react';
import {BackButton} from '../../Components/Buttons/BackButton';
import {CardContainer} from '../../Components/CardContainer/CardContainer';
import {CreateAndUpdateForm} from '../../Components/FormGenerators/CreateAndUpdateForm';
import {
  IEditableEventSubject,
} from '../../Components/FormGenerators/IEditableEventSubject';
import {RowOfButtons} from '../../Components/Layout/RowOfButtons';
import PageTitle from '../../Components/PageTitle/PageTitle';
import RedirectTo404 from '../../Components/RedirectTo404';
import {LMessages} from '../../Localization/Localization';
import {IPageInterface} from '../entity/IPageInterface';
import {
  EventSubjectEntity,
  useGetEntityDetails,
} from '../entity/useGetEntityDetails';
import {EventSubjectUpdateFields} from './fields';

/**
 * Event subject's update card.
 * @param {string | undefined} id
 * @return {JSX.Element}
 * @constructor
 */
export default function EventSubjectUpdateCard({id}: IPageInterface) {
  const emptyEntity = {} as IEditableEventSubject;
  const {data, isError} = useGetEntityDetails<IEditableEventSubject>(
    EventSubjectEntity.name,
    id as string,
    emptyEntity,
  );

  const {enqueueSnackbar} = useSnackbar();

  return (
    <React.Fragment>
      <RedirectTo404 isError={isError}/>

      {data && !R.isEmpty(data) ? <PageTitle
        title={`${LMessages.EVENT_SUBJECT_U_CARD_TITLE} ${data.name}`}
      /> : null}

      <RowOfButtons>
        <BackButton/>
      </RowOfButtons>

      {
        !R.isEmpty(data) ?
          <CardContainer>
            <CreateAndUpdateForm<IEditableEventSubject>
              action={'EVENT_SUBJECT_UPDATE'}
              id={id}
              fields={EventSubjectUpdateFields}
              data={data as IEditableEventSubject}
              snackBar={enqueueSnackbar}
            />
          </CardContainer> :
          null
      }

    </React.Fragment>
  );
}


